import React from 'react';

import HeroIntro from './HeroIntro';
import HeroVideoBackdrop from './HeroVideoBackdrop';

/**
 * ### HeroBanner
 *
 * The first screen of the home page: the brand statement centred over the
 * background video, and nothing else. The scroll-driven story follows, then
 * the press-kit claim with its metrics and the calls to action, so the hero
 * can be read at a glance and the video is what fills the screen.
 *
 * @returns The rendered hero section element
 */
export default function HeroBanner() {
  return (
    <section
      className="relative flex min-h-[100svh] flex-col justify-center overflow-hidden bg-apps-brandGrayBlack"
      data-analytics-section="home_hero"
    >
      <HeroVideoBackdrop />
      <div className={`relative z-[1] pb-10 lg:pb-16 pt-[72px] lg:pt-[124px]`}>
        <HeroIntro />
      </div>
    </section>
  );
}
